import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block border-r border-b border-border"
    >
      <div className="relative overflow-hidden aspect-[3/4] bg-secondary">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
        />
        {product.featured && (
          <span className="absolute top-3 left-3 bg-accent text-accent-foreground text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-1">Featured</span>
        )}
      </div>
      <div className="p-4">
        <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-muted-foreground">{product.category}</div>
        <div className="font-medium mt-1 group-hover:text-accent transition-colors">{product.name}</div>
        <div className="font-mono text-sm mt-1">£{product.price.toFixed(2)}</div>
      </div>
    </Link>
  );
}
